module.exports = __webpack_public_path__ + "img/icon_map_water_lixian.938a33ba.svg";